
import SeletorDeData from '@/common/Data/SeletorDeData.vue'
import CurrentTime from '@/common/CurrentTime.vue'
import moment from 'moment'
import Vue, { VueConstructor } from 'vue'
import { Data, Methods, Computed, DayJourney, DadosJornadaDoDia, IRequestSolicitacaoHorasExtras } from '../SolicitacaoHorasExtras.modelo'
import { InputHoraEMinutoRef } from '@/common/inputs/inputHoraEMinuto/inputHoraEMinuto.modelo'
import { SeletorDeDataRef } from '@/common/Data/SeletorDeData.modelo'
import { gerarUrlJornadaDoDia, gerarUrlPedidoDeHorasExtras } from '@/api'
import {
  ValidadorDePedidoDeHorasExtras,
  Jornada,
  estiloJornada,
  tipoDeJornada,
  TipoDeJornada,
  PedidoIntercedeJornadaDoDia,
  ErroPedidoHorariosIguais
} from 'funcoes-compartilhadas-pontotel/lib/contextos/governanca/pedidoDeHorasExtras'

export default (Vue as VueConstructor<Vue &
  { $refs:
    {
      horarioInicio: InputHoraEMinutoRef,
      horarioFim: InputHoraEMinutoRef,
      seletorData: SeletorDeDataRef
     };
  }
>).extend<Data, Methods, Computed>({
  name: 'SolicitacaoHoraExtra',
  data () {
    const validadorJornada = new ValidadorDePedidoDeHorasExtras(new Date(), new Jornada('08:00', '18:00'), new Jornada('00:00', '00:00'))
    return {
      justificativa: '',
      mensagemErroJustifiacativa: '',
      avisoHorarioInicio: '',
      avisoHorarioFim: '',
      data: new Date(),
      dataMinima: new Date(),
      horarioInicio: null,
      horarioFim: null,
      estaRealizandoPedido: false,
      estaBuscandoJornada: false,
      legendaJornadaEsperada: null,
      mostrandoAvisoDiaHoraJornada: false,
      configuracoesDiasDisponiveisPedido: new Map(),
      dadosDasJornadasDisponiveis: new Map(),
      validadorJornada
    }
  },
  computed: {
    configuracaoDiaEscolhido () {
      const chave = moment(this.data).format('YYYY-MM-DD')
      return this.configuracoesDiasDisponiveisPedido.get(chave) || null
    },
    dadosDaJornadaDoDia () {
      const chave = moment(this.data).format('YYYY-MM-DD')
      return this.dadosDasJornadasDisponiveis.get(chave) || null
    },
    dataMaxima () {
      const MAXIMO_DIAS_PARA_SOLICITAR_HORAS_EXTRAS = 3
      const hoje = new Date()
      const dataMaxima = hoje.setDate(hoje.getDate() + (MAXIMO_DIAS_PARA_SOLICITAR_HORAS_EXTRAS - 1))
      return new Date(dataMaxima)
    },
    jornadaDoDiaAtual () {
      const jornada = this.$store.getters['sincronizador/jornadaDoDia']
      if (!jornada) return null
      return {
        nome: jornada.nome,
        diaDaJornada: jornada.dia
      }
    },
    dataComHorarioInicio () {
      return this.$refs.horarioInicio?.converterStringHoraEMinutoParaData(this.data) as Date
    },
    dataComHorarioFim () {
      return this.$refs.horarioFim?.converterStringHoraEMinutoParaData(this.data) as Date
    },
    mostrarJornadaEsperada () {
      return this.data && !!this.legendaJornadaEsperada
    },
    empregadoId () {
      return this.$store.state.sincronizador.sincronizacaoUsuario.empregado?.id
    },
    estiloJornada () {
      const configuracaoJornada = this.configuracaoDiaEscolhido
      if (!configuracaoJornada) {
        return {
          '--corDaJornada': '#EEE'
        }
      }

      return estiloJornada(configuracaoJornada)
    }
  },
  methods: {
    voltarParaMarcacao () {
      this.$router.push({ name: 'marcacao' })
    },
    verificarSeHorarioInicioEhValido () {
      return this.$refs.horarioInicio?.validarHorario()
    },
    verificarSeHorarioFimEhValido () {
      return this.$refs.horarioFim?.validarHorario()
    },
    verificarSeDataEhValida () {
      return !this.$refs.seletorData?.verificarDataAtualEstaDesabilitada(this.data)
    },
    verificarSeHorarioInicioEhAntesDaHoraAtual () {
      if (!this.dataComHorarioInicio) {
        return false
      }
      return this.dataComHorarioInicio < new Date()
    },
    validarCamposObrigatorios () {
      let camposValidos = true
      if (!this.justificativa) {
        this.mensagemErroJustifiacativa = this.$t('comum.inputs.inputGeneric.campoNecessario') as string
        camposValidos = false
      }

      if (this.verificarSeHorarioInicioEhAntesDaHoraAtual()) {
        this.avisoHorarioInicio = this.$t('componentes.solicitacoes.views.solicitacaoHorasExtras.erroInicioNoPassado') as string
        camposValidos = false
      }

      if (!this.verificarSeHorarioInicioEhValido()) {
        camposValidos = false
      }
      if (!this.verificarSeHorarioFimEhValido()) {
        camposValidos = false
      }

      if (!this.verificarSeDataEhValida()) {
        this.$refs.seletorData.mensagemErro = this.$t('comum.inputs.seletorDeData.dataInvalida') as string
        camposValidos = false
      }

      return camposValidos
    },
    validarPedidoDeHorasExtras () {
      const camposValidos = this.validarCamposObrigatorios()
      if (!camposValidos) {
        this.mostrandoAvisoDiaHoraJornada = false
        this.avisoHorarioFim = ''
        return false
      }

      this.validadorJornada.atualizarJornadaDeHorasExtras(
        this.dataComHorarioInicio,
        this.dataComHorarioFim
      )

      // if (this.configuracaoDiaEscolhido?.ehDiaDeTrabalho) {
      //   this.validadorJornada.validarJornada()
      // }

      if (this.horarioInicio === this.horarioFim) {
        throw new ErroPedidoHorariosIguais()
      }

      return true
    },
    async salvarPedido () {
      const corpoRequisicao = (): IRequestSolicitacaoHorasExtras => {
        const [inicioJornada, fimJornada] = this.validadorJornada.pegarPedidoFormatado()

        const corpoRequisicao: IRequestSolicitacaoHorasExtras = {
          justificativa: this.justificativa,
          diaDaJornada: moment(this.data).format('YYYY-MM-DD'),
          inicioDaHoraExtra: moment(inicioJornada).format('YYYY-MM-DDTHH:mm:ss'),
          fimDaHoraExtra: moment(fimJornada).format('YYYY-MM-DDTHH:mm:ss'),
          empregado: this.empregadoId,
          quemEstaPedindo: this.empregadoId
        }

        return corpoRequisicao
      }

      try {
        this.estaRealizandoPedido = true

        if (!this.validarPedidoDeHorasExtras()) {
          return
        }

        await this.$http.post(gerarUrlPedidoDeHorasExtras(), corpoRequisicao())
      } catch (erro: unknown) {
        let textoGenerico = this.$t('componentes.solicitacoes.views.solicitacaoHorasExtras.erroGenerico.texto') as string
        let tituloGenerico = this.$t('componentes.solicitacoes.views.solicitacaoHorasExtras.erroGenerico.titulo') as string

        const definirTextosErro = (descricao: string | undefined, error: string | undefined) => {
          let texto = textoGenerico
          let titulo = tituloGenerico
          if (descricao && error && descricao.length > error.length) {
            texto = descricao || textoGenerico
            titulo = tituloGenerico || tituloGenerico
          } else if (descricao && error && descricao.length < error.length) {
            texto = error || textoGenerico
            titulo = tituloGenerico || tituloGenerico
          }

          return { texto, titulo }
        }

        if (erro?.body?.error === 'Sua solicitação foi feita com sucesso!') {
          this.$store.commit('solicitacao/salvarDadosConfirmacaoPedido', corpoRequisicao())
          this.$router.push({ name: 'confirmacaoPedido' })
          return
        } else if (erro instanceof PedidoIntercedeJornadaDoDia) {
          textoGenerico = this.$t('componentes.solicitacoes.views.solicitacaoHorasExtras.erroSolicitacaoDentroDaJornada') as string
        } else if (erro instanceof ErroPedidoHorariosIguais) {
          textoGenerico = this.$t('componentes.solicitacoes.views.solicitacaoHorasExtras.erroHorariosIguais') as string
        } else if (erro?.status === 400) {
          const { description, error } = erro.body
          const { texto, titulo } = definirTextosErro(description, error)
          textoGenerico = texto
          tituloGenerico = titulo
        }

        this.$swal({
          type: 'error',
          title: tituloGenerico,
          text: textoGenerico
        })
      } finally {
        this.estaRealizandoPedido = false
      }
    },
    async atualizarSeletorData () {
      this.avisoHorarioInicio = null
      // await this.buscarJornadaEsperada()
    },
    /**
     * TODO
     * Comentado temporariamente pois esta API do condomínio não aceita o token do GC
     * esta api serve para consultar a jornada do dia e fazer a validação do pedido direto no front
     * além de mostrar a jornada esperada para o dia em tela
     */
    // async buscarInformacoesJornadaApi () {
    //   try {
    //     this.estaBuscandoJornada = true
    //     const corpoRequisicao = {
    //       startDate: moment(this.data).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).format('YYYY-MM-DDTHH:mm:ss'),
    //       endDate: moment(this.data).add(2, 'days').set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).format('YYYY-MM-DDTHH:mm:ss'),
    //       employees: [this.empregadoId],
    //       infoToRefetch: null
    //     }

    //     const resposta = await this.$http.post(gerarUrlJornadaDoDia(), corpoRequisicao)

    //     const jornadaApi: DayJourney[] = resposta.data.success.lines.map((linha: DayJourney) => linha)
    //     const dadosJornadaDiasDisponiveis: Map<string, DadosJornadaDoDia> = new Map()

    //     jornadaApi.forEach((jornada: DayJourney) => {
    //       const diaJornada = moment(jornada.day).format('YYYY-MM-DD')
    //       this.configuracoesDiasDisponiveisPedido.set(diaJornada, tipoDeJornada(jornada))
    //       dadosJornadaDiasDisponiveis.set(diaJornada, {
    //         legenda: jornada.journey.name,
    //         inicioJornada: new Date(jornada.journey.start),
    //         fimJornada: new Date(jornada.journey.end),
    //         diaJornada: new Date(jornada.day)
    //       })
    //     })

    //     return dadosJornadaDiasDisponiveis
    //   } catch (erro: unknown) {
    //     this.$swal({
    //       type: 'error',
    //       title: this.$t('componentes.solicitacoes.views.solicitacaoHorasExtras.erroBuscarJornada.titulo') as string,
    //       text: this.$t('componentes.solicitacoes.views.solicitacaoHorasExtras.erroBuscarJornada.texto') as string
    //     })
    //     throw erro
    //   } finally {
    //     this.estaBuscandoJornada = false
    //   }
    // },
    // async buscarJornadaEsperada () {
    //   let dadosDaJornada: DadosJornadaDoDia
    //   const chaveDiaSelecionado = moment(this.data).format('YYYY-MM-DD')
    //   const jaBuscouPreviamenteAJornada = () => this.configuracoesDiasDisponiveisPedido.has(chaveDiaSelecionado)

    //   if (jaBuscouPreviamenteAJornada()) {
    //     dadosDaJornada = this.dadosDaJornadaDoDia as DadosJornadaDoDia
    //   } else {
    //     this.dadosDasJornadasDisponiveis = await this.buscarInformacoesJornadaApi()
    //     dadosDaJornada = this.dadosDaJornadaDoDia as DadosJornadaDoDia
    //   }

    //   this.legendaJornadaEsperada = dadosDaJornada.legenda

    //   this.validadorJornada
    //     .atualizarDataDoPedido(dadosDaJornada.diaJornada)
    //     .atualizarJornadaDoDia(dadosDaJornada.inicioJornada, dadosDaJornada.fimJornada)
    // },
    definirLegendaSeletoresDeHora () {
      const regex = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/
      const legenda = `HH:mm [${this.$t('componentes.solicitacoes.views.solicitacaoHorasExtras.doDia')}] DD/MM/YYYY`
      if (
        !regex.test(this.horarioInicio as string) ||
        !regex.test(this.horarioFim as string) ||
        !this.data) {
        this.avisoHorarioInicio = ''
        this.avisoHorarioFim = ''
        this.mostrandoAvisoDiaHoraJornada = false
        return
      }

      const formatarDataHoraLegenda = (data: Date): string => (moment(data).format(legenda))

      const [inicioHoras, inicioMinutos] = (this.horarioInicio as string).split(':').map(Number)
      const [fimHoras, fimMinutos] = (this.horarioFim as string).split(':').map(Number)

      const inicioEmDate = new Date()
      inicioEmDate.setHours(inicioHoras, inicioMinutos, 0, 0)
      const fimEmDate = new Date()
      fimEmDate.setHours(fimHoras, fimMinutos, 0, 0)

      const [dataHoraInicio, dataHoraFim] = this.validadorJornada.atualizarJornadaDeHorasExtras(
        Jornada.concatenarDataEmHorario(this.data, inicioEmDate),
        Jornada.concatenarDataEmHorario(this.data, fimEmDate)
      ).pegarPedidoFormatado()

      this.mostrandoAvisoDiaHoraJornada = true
      this.avisoHorarioInicio = formatarDataHoraLegenda(dataHoraInicio)
      this.avisoHorarioFim = formatarDataHoraLegenda(dataHoraFim)
    }
  },
  filters: {
    formatarData (data: Date) {
      return moment(data).format('DD/MM/YYYY')
    }
  },
  watch: {
    data () {
      this.definirLegendaSeletoresDeHora()
    },
    horarioInicio () {
      this.definirLegendaSeletoresDeHora()
    },
    horarioFim () {
      this.definirLegendaSeletoresDeHora()
    }
  },
  /**
   * TODO
   * Comentado temporariamente pois esta API do condomínio não aceita o token do GC
   * esta api serve para consultar a jornada do dia e fazer a validação do pedido direto no front
   * além de mostrar a jornada esperada para o dia em tela
   */
  // async mounted() {
  // await this.buscarJornadaEsperada()
  // },
  components: {
    CurrentTime,
    SeletorDeData
  }
})
